var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"studio-location"},[_c('p',{staticClass:"location-title"},[_vm._v("Location")]),_c(_setup.GmapsPlaceInput,{attrs:{"placeholder":"Address of the studio"},model:{value:(_setup.location),callback:function ($$v) {_setup.location=$$v},expression:"location"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }